<template>
    <div class="index">
        <div class="top">
            <el-steps :active="stepsActive" simple finish-status="process" process-status="finish" style="width:1100px;margin-left:20px">
                <el-step title="新任务" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务待派调查员" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务作业中" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务待机构审核" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务待总部审核" :icon="stepsActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务退回" :icon="stepsActive>5?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务完成" :icon="stepsActive>6?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="取消委托" :icon="stepsActive>7?'el-icon-folder-checked':'el-icon-edit'" v-if="stepsActive==7"></el-step>
            </el-steps>
            <div style="margin-right:10px">
                <el-button type="primary" icon="el-icon-edit-outline" v-if="stepsActive==0" @click="receiveDoubtTaskTip">接受</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" @click="isApplyDispatchTip = true" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">申请加派/延期</el-button>
                <!-- <el-button type="danger" icon="el-icon-edit-outline" v-if="(stepsActive==2||stepsActive==3||stepsActive==5)&&isRolesCancel==true&&!isBigCase" @click="cancelCaseTip">回销案件</el-button>
                <el-button type="primary" icon="el-icon-edit-outline" v-else-if="stepsActive==2||stepsActive==3||stepsActive==5" @click="submitAuditTip()">提交审核</el-button> -->


                <el-button type="danger" icon="el-icon-edit-outline" v-if="(stepsActive==2||stepsActive==3||stepsActive==5)&&isDestroyCase" @click="cancelCaseTip">回销案件</el-button>

                <el-button type="danger" icon="el-icon-edit-outline" v-else-if="(stepsActive==2||stepsActive==3||stepsActive==5)&&surveyDataInfo.dcTaskPgMechanism=='广州天信保险公估有限公司'" @click="submitAuditTip">提交审核</el-button>

                <el-button type="primary" icon="el-icon-upload2" v-else-if="(stepsActive==2||stepsActive==3||stepsActive==5)&&(myMechanismId!=surveyDataInfo.dcTaskPgMechanismId)" @click="submitZyJgReviewTip()">提交展业机构审核</el-button>
                <el-button type="danger" icon="el-icon-edit-outline" v-else-if="(stepsActive==2||stepsActive==3||stepsActive==5)&&!isBigCase" @click="cancelCaseTip">回销案件</el-button>

                <el-button type="primary" icon="el-icon-upload2" v-else-if="stepsActive==2||stepsActive==3||stepsActive==5" @click="submitAuditTip()">提交审核</el-button>
            </div>
             <!-- :disabled="!isComplete" -->
        </div>
        <div class="taskreason" v-if="stepsActive==3||stepsActive==5">
            <span>*</span>
            审核退回原因： 
            {{detailData.taskReason}}
        </div>

        <el-tabs type="border-card" @tab-click="changeTab" v-model="tabVal">
            <el-tab-pane label="案件信息">
                <div :style="height+';overflow-y: scroll;'">
                    <div class="section">
                        <div class="title">
                            基础信息
                        </div>
                        <div class="item">
                            <div class="label">
                                赔案号
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cClmNo" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>

                       
                        <div class="item">
                            <div class="label">
                                调查意见
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    <div class="" v-for="(item,index) in cDoubtOpinList" :key="index">
                                        {{item}}
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="value" style="width:590px">
                                <el-input v-model="surveyDataInfo.cDoubtOpin" placeholder="" size="small" type="textarea"></el-input>
                            </div> -->
                        </div>
                        <div class="item">
                            <div class="label">
                                派工时间
                            </div>
                            <el-date-picker
                            v-model="surveyDataInfo.dcTaskPgTime"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        <div class="item">
                            <div class="label">
                                调查要求
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    <div class="" v-for="(item,index) in dcyqList" :key="index">
                                        {{item}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                公估费用
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.taskFee" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <!-- <div class="item">
                            <div class="label">
                                加派原因
                            </div>
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    {{surveyDataInfo.jpyq}}
                                </div>
                            </div>
                        </div> -->

                        <div class="item">
                            <div class="label">
                                案件状态:
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.dcTaskAction" size="small" placeholder="请选择" @change="isBigCaseChange" disabled>
                                    <el-option
                                    v-for="item in DcTaskActionList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                财务状态:
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.financeState" size="small" placeholder="请选择" @change="isBigCaseChange" disabled>
                                    <el-option
                                    v-for="item in financeStateList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="item">
                            <div class="label">
                                调查时效类型:
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.dcSx" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                是否时效内结案:
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.sxnja" size="small" placeholder="请选择" @change="isBigCaseChange" disabled>
                                    <el-option
                                    v-for="item in isBigList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                调查处理剩余时效:
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.ljgzsx" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                    </div>
                
                    <div class="section">
                        <div class="title">
                            保险信息
                        </div>
                        <div class="item">
                            <div class="label">
                                保险公司
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.companyName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                险种类型
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cProdType" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                保障产品
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cProdName" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                保单号
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cPlyNo" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                投保时间
                            </div>
                            <el-date-picker
                            v-model="surveyDataInfo.tInsAddTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        
                        <div class="item">
                            <div class="label">
                                被保人
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cInsuredNme" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                被保人证件类型
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.cCertType" size="small" placeholder="请选择" @change="bzProductIdChange" class="citem-input" disabled>
                                    <el-option
                                    v-for="item in InsuredNoTypeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                    
                        <div class="item">
                            <div class="label">
                                被保人证件号
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cCertNo" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="section">
                        <div class="title">
                            出险信息
                        </div>
                        <div class="item">
                            <div class="label">
                                出险人
                            </div>
                            <div class="value">
                                <el-input v-model="detailData.personDanger" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                出险时间
                            </div>
                            <div class="value">
                                <el-date-picker
                                v-model="surveyDataInfo.tAccdntTm"
                                type="datetime"
                                size="small"
                                class="citem-input"
                                disabled
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                                </el-date-picker>
                            </div>
                        </div>
                        <!-- <div class="item">
                            <div class="label">
                                出险地区
                            </div>
                            <div class="value">
                                <el-cascader
                                size="small"
                                :options="regionData"
                                v-model="surveyDataInfo.cAccdntPlace"
                                @change="handleRegionChange">
                                </el-cascader>
                            </div>
                        </div> -->
                        <div class="item">
                            <div class="label">
                                出险地点
                            </div>
                            <div class="value" style="width:590px">
                                <el-input v-model="surveyDataInfo.cAccdntPlace" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                出险经过
                            </div>
                            
                            <div class="value" style="width:590px">
                                <div class="value-textarea">
                                    <div class="" v-for="(item,index) in cAccdntProList" :key="index">
                                        {{item}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="section">
                        <div class="title">
                            报案信息
                        </div>
                        <div class="item">
                            <div class="label">
                                报案人
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cRptName" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                报案人电话
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.cRptTell" placeholder="" size="small" class="citem-input" disabled></el-input>
                            </div>
                        </div>
                    
                        <div class="item">
                            <div class="label">
                                报案时间
                            </div>
                            <el-date-picker
                            v-model="surveyDataInfo.tRptTm"
                            type="datetime"
                            size="small"
                            class="citem-input"
                            disabled
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                        
                    </div>
                   
<!--  -->
                    
                </div>
            </el-tab-pane>
            <el-tab-pane label="派工资料信息">
                <div :style="height+';overflow-y: scroll;'">
                    <div class="section">
                        <div class="title">
                            调查信息
                        </div>
                        <div style="width:100%">
                        
                            <el-table
                                :data="surveyData"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                >
                                <el-table-column
                                type="index"
                                label="序号"
                                width="60"
                                align="center"
                                >
                                </el-table-column>
                            
                                <el-table-column
                                prop="cSvyNeed"
                                label="调查需求"
                                align="center"
                                width="400">
                                </el-table-column>
                                <el-table-column
                                prop="tHopeEndTm"
                                label="期望完成时间"
                                align="center"
                                width="240">
                                <template slot-scope="scope">
                                    <span style="color:red">{{scope.row.tHopeEndTm}}</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cSvyType"
                                label="疑似类型"
                                align="center"
                                width="150">
                                </el-table-column>
                                <el-table-column
                                prop="cSvyMode"
                                label="案件类型"
                                align="center"
                                width="120">
                                </el-table-column>
                                <el-table-column
                                prop="cSvyPlace"
                                label="调查地点"
                                align="center"
                                >
                                </el-table-column>
                                
                                <el-table-column
                                prop="cSvyAddr"
                                label="调查地址"
                                align="center"
                                >
                                </el-table-column>
                            
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="100px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="surveyDataDetail(scope.row)">查看详情</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="section">
                        <div class="title">
                            派工资料
                        </div>
                        <div style="width:100%">
                            <div class="materiallist">
                                <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                                    <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                    <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                    <el-image
                                    style="width: 120px; height: 120px"
                                    :src="item.path"
                                    v-else
                                    @click="showImgm(item.path,surveyInfo)"
                                    :fit="cover"></el-image>
                                    
                                    <div class="filename">{{item.name}}</div>
                                </div>
                            </div>
                            <div class="btns">
                                <el-button type="primary" icon="el-icon-download" @click="downloadSurveyInfo">下载派工资料</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <!-- <el-tab-pane label="派工资料">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in surveyInfo" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.materialType=='mp3'||item.materialType=='aac'||item.materialType=='wav'||item.materialType=='wma'||item.materialType=='flac'||item.materialType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.materialType=='rmvb'||item.materialType=='rm'||item.materialType=='ts'||item.materialType=='tp'||item.materialType=='avi'||item.materialType=='3gp'||item.materialType=='mp4'||item.materialType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.materialType=='xls'||item.materialType=='xlsx'||item.materialType=='doc'||item.materialType=='docx'||item.materialType=='ppt'||item.materialType=='pptx'||item.materialType=='pdf'||item.materialType=='zip'||item.materialType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path"
                                v-else
                                @click="showImgm(item.path,surveyInfo)"
                                :fit="cover"></el-image>
                                
                                <div class="filename">{{item.name}}</div>
                            </div>
                        </div>
                        <div class="btns">
                            <el-button type="primary" icon="el-icon-download" @click="downloadSurveyInfo">下载派工资料</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane> -->
            
            
            <!-- <el-tab-pane label="调查员">
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==5">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="assignPersonTip">指派人员</el-button>
                            </div>
                        </div>
                        <el-table
                            :data="personTaskList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width:100%"
                            >
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operatorMechanism"
                            label="归属机构"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="creationTime"
                            label="指派时间"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operator"
                            label="调查员"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="executeAction"
                            label="任务状态"
                            align="center"
                            >
                            <template slot-scope="scope">

                                {{scope.row.executeAction==0?"新任务":""}}
                                {{scope.row.executeAction==10?"任务待派调查员":""}}
                                {{scope.row.executeAction==20?"任务作业中":""}}
                                {{scope.row.executeAction==25?"任务待机构审核":""}}
                                {{scope.row.executeAction==26?"异地作业审核":""}}
                                {{scope.row.executeAction==30?"任务完成":""}}
                                {{scope.row.executeAction==40?"任务退回":""}}
                                {{scope.row.executeAction==50?"任务完成":""}}
                                {{scope.row.executeAction==70?"取消委托":""}}
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="dcyq"
                            label="派工备注"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            label="操作"
                            width="300px"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelAssign(scope.row)" v-if="(stepsActive==2||stepsActive==1||stepsActive==3||stepsActive==5)&&scope.row.update">取消指派</el-button>
                                <el-button type="text" icon="el-icon-delete" size="mini" @click="backTask(scope.row)" v-if="stepsActive==5&&(scope.row.executeAction==30||scope.row.executeAction==50)">退回任务</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane> -->
            <el-tab-pane label="调查作业信息">
                <div :style="height+';overflow-y: scroll;'">
                    <div class="section">
                        <div class="title">
                            作业机构
                        </div>
                        <el-table
                            :data="otherJgList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operatorMechanism"
                            label="作业机构"
                            align="center"
                            >
                            </el-table-column>
                            <!-- <el-table-column
                            prop="dispatcher"
                            label="调度人"
                            align="center"
                            >
                            </el-table-column> -->
                            <el-table-column
                            prop="executeAction"
                            label="任务状态"
                            align="center"
                            >
                            <template slot-scope="scope">
                                {{scope.row.executeAction==0?"新任务":""}}
                                {{scope.row.executeAction==10?"任务待派调查员":""}}
                                {{scope.row.executeAction==20?"任务作业中":""}}
                                {{scope.row.executeAction==25?"任务待机构审核":""}}
                                {{scope.row.executeAction==26?"异地作业审核":""}}
                                {{scope.row.executeAction==30?"任务待总部审核":""}}
                                {{scope.row.executeAction==40?"任务退回":""}}
                                {{scope.row.executeAction==50?"任务完成":""}}
                                {{scope.row.executeAction==70?"取消委托":""}}

                            </template>
                            
                            </el-table-column>
                            <el-table-column
                            prop="taskFee"
                            label="公估费用"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="rewardFee"
                            label="奖励费用"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="isZhuPaiJiGou"
                            label="是否主案"
                            align="center"
                            >
                            <template slot-scope="scope">
                                {{scope.row.isZhuPaiJiGou?"是":"否"}}
                            </template>
                            </el-table-column>
                            <el-table-column
                            prop="dcyq"
                            label="派工备注"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            fixed="right"
                            label="操作"
                            width="280px"
                            align="center"
                            >
                            <template slot-scope="scope">
                                <el-button type="text" icon="el-icon-edit" size="mini" @click="editTaskFeeTip(scope.row)" v-if="(stepsActive==1||stepsActive==2||stepsActive==5)&&(myMechanismId==scope.row.operatorMechanismId)">编辑奖励费用</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="section">
                        <div class="title">
                            调查员
                        </div>
                        <div style="width:100%">
                            <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==5">
                                <div>
                                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="assignPersonTip">指派人员</el-button>
                                </div>
                            </div>
                            <el-table
                                :data="personTaskList"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                >
                                <el-table-column
                                type="index"
                                width="80"
                                label="序号"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="operatorMechanism"
                                label="归属机构"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="creationTime"
                                label="指派时间"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="operator"
                                label="调查员"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="executeAction"
                                label="任务状态"
                                align="center"
                                >
                                <template slot-scope="scope">

                                    {{scope.row.executeAction==0?"新任务":""}}
                                    {{scope.row.executeAction==10?"任务待派调查员":""}}
                                    {{scope.row.executeAction==20?"任务作业中":""}}
                                    {{scope.row.executeAction==25?"任务待机构审核":""}}
                                    {{scope.row.executeAction==26?"异地作业审核":""}}
                                    {{scope.row.executeAction==30?"任务完成":""}}
                                    {{scope.row.executeAction==40?"任务退回":""}}
                                    {{scope.row.executeAction==50?"任务完成":""}}
                                    {{scope.row.executeAction==70?"取消委托":""}}
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="dcyq"
                                label="派工备注"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="300px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="cancelAssign(scope.row)" v-if="(stepsActive==2||stepsActive==1||stepsActive==3||stepsActive==5)&&scope.row.update">取消指派</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="backTask(scope.row)" v-if="stepsActive==5&&(scope.row.executeAction==30||scope.row.executeAction==50)">退回任务</el-button>
                                    <!-- <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="personDetail(scope.row)">查看资料</el-button> -->
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>

                    <div class="section">
                        <div class="title">
                            调查信息
                        </div>
                        <div class="handle" style="margin:0 10px;width:100%">
                            <div>
                                <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="doubtCourseAddTip()" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5" >添加调查节点</el-button>
                                <el-button type="primary" size="mini" @click="downFileAnXinDcTask">下载调查资料</el-button>
                            </div>
                        </div>
                        <div class="section-item" v-for="(mitem,mindex) in doubtCourseList" :key="mindex" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle">
                                <div class="stitle-l">
                                    {{mitem.operator}} <span>({{mitem.operatorMechanism}})</span> 
                                    <div class="stitle-r">
                                        {{mitem.executeAction==0?'待接收':''}} 
                                        {{mitem.executeAction==10?'待派工':''}} 
                                        {{mitem.executeAction==20?'调查中':''}} 
                                        {{mitem.executeAction==25?'待审核':''}} 
                                        {{mitem.executeAction==30?'审核通过':''}} 
                                        {{mitem.executeAction==40?'任务退回':''}} 
                                        {{mitem.executeAction==50?'完成':''}} 
                                    </div>
                                    <img src="../../../assets/images/icon14x.png" alt="" v-if="mitem.isOpen" @click="changeIsOpen(mindex)"/>
                                    <img src="../../../assets/images/icon14.png" alt="" v-else @click="changeIsOpen(mindex)"/>
                                    
                                </div>
                                    
                                

                                <div class="stitle-audit">
                                    <el-button type="text" icon="el-icon-edit-outline" @click="noAudit(mitem)" v-if="mitem.executeAction==25||stepsActive==5">审核退回</el-button>
                                    <el-button type="text" icon="el-icon-edit-outline" @click="auditTip(mitem)" v-if="mitem.executeAction==25">审核通过</el-button>
                                    <!-- <el-button type="text" icon="el-icon-edit-outline" @click="noAudit(mitem)" v-if="mitem.executeAction==25||stepsActive==5">审核退回</el-button>
                                    <el-button type="text" icon="el-icon-edit-outline" @click="audit(mitem)" v-if="mitem.executeAction==25">审核通过</el-button> -->
                                </div>
                            </div>
                            <el-table
                                :data="mitem.doubtCourses"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                v-if="mitem.isOpen"
                                >
                                <el-table-column
                                type="index"
                                label="序号"
                                width="60"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="dcTaskSubJect"
                                label="调查节点"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="tCourTm"
                                label="调查时间"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourAddr"
                                label="调查省级市"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourPlace"
                                label="调查地点"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPlace==1">医院</span>
                                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourPro"
                                label="调查项目"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                                </template>
                                </el-table-column>
                            
                                <el-table-column
                                prop="cCourMode"
                                label="案件类型"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourOperNme"
                                label="被调查人姓名"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourRela"
                                label="被调查人与被保人关系"
                                align="center"
                                width="180px"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cProcess"
                                label="调查过程"
                                align="center"
                                width="150px"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                                </template>
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="220px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                    <el-button type="text" icon="el-icon-download" size="mini" v-loading.fullscreen.lock="fullscreenLoading" @click="downFileDoubtCourse(scope)">下载资料</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle" >
                                <div class="stitle-l">
                                    其他
                                    <img src="../../../assets/images/icon14x.png" v-if="isOtherDoubtCourseListOpen" @click="isOtherDoubtCourseListOpen = false"/>
                                    <img src="../../../assets/images/icon14.png" v-else @click="isOtherDoubtCourseListOpen = true"/>
                                </div>
                            </div>
                            <el-table
                                :data="otherDoubtCourseList"
                                border
                                :header-cell-style="tableHeaderColor"
                                style="width:100%"
                                v-if="isOtherDoubtCourseListOpen"
                                >
                                <el-table-column
                                type="index"
                                label="序号"
                                width="60"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="dcTaskSubJect"
                                label="调查节点"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="tCourTm"
                                label="调查时间"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourAddr"
                                label="调查省级市"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourPlace"
                                label="调查地点"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPlace==1">医院</span>
                                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourPro"
                                label="调查项目"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                                </template>
                                </el-table-column>
                            
                                <el-table-column
                                prop="cCourMode"
                                label="案件类型"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cCourOperNme"
                                label="被调查人姓名"
                                align="center"
                                >
                                </el-table-column>
                                <el-table-column
                                prop="cCourRela"
                                label="被调查人与被保人关系"
                                align="center"
                                width="180px"
                                >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                                </template>
                                </el-table-column>
                                <el-table-column
                                prop="cProcess"
                                label="调查过程"
                                align="center"
                                width="150px"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                                </template>
                                </el-table-column>
                                <el-table-column
                                fixed="right"
                                label="操作"
                                width="220px"
                                align="center"
                                >
                                <template slot-scope="scope">
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                                    <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                                    <el-button type="text" icon="el-icon-download" size="mini" @click="downFileDoubtCourse(scope)">下载资料</el-button>
                                </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <!-- <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                            <div class="stitle">
                                <div class="stitle-l">
                                    报告
                                </div>
                                <div class="stitle-audit">
                                    <el-button type="text" icon="el-icon-download" size="small" @click="querayDcTaskOperatorByAnXinDcTaskId">生成报告</el-button>
                                </div>
                            </div>
                            <div class="materiallist">
                                <div class="material" v-if="report.path">
                                    <img src="../../../assets/images/icon13.png" alt="" :fit="cover" @click="download(report.path,report.name)">
                                    <div class="filename">{{report.fileName}}</div>
                                </div>
                            </div>
                        </div> -->
                        
                    </div>
                    
                    <div class="section">
                        <div class="title">
                            调查报告
                        </div>
                        <div class="section-item" style="margin:0 10px;padding-top:10px;width:100%">
                            
                            <div class="materiallist">
                                <div class="material" v-if="report.path">
                                    <img src="../../../assets/images/icon13.png" alt="" fit="cover" @click="download(report.path,report.name)">
                                    <div class="filename">{{report.fileName}}</div>
                                    <img src="../../../assets/images/icon08.png" class="close" @click="deleteDoubTaskMaterialTip(report.id)" alt=""  v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">
                                </div>
                                <el-upload
                                :action="uploadUrl"
                                multiple
                                :show-file-list="false"
                                :http-request="uploadPDF"
                                v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5"
                                >
                                    <el-button type="success" icon="el-icon-upload" size="small" style="margin:0 10px">上传报告</el-button>
                                </el-upload>
                                <el-button type="primary" icon="el-icon-download" size="small" @click="querayDcTaskOperatorByAnXinDcTaskId" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">生成报告</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="section">
                        <div class="title">
                            调查结论
                        </div>
                        <div class="item">
                            <div class="label">
                                调查结论
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.cConclusion" size="small" placeholder="" @change="isBigCaseChange">
                                    <el-option
                                    v-for="item in cConclusionList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="surveyDataInfo.cConclusion" placeholder="" size="small" disabled></el-input> -->
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                调查意见
                            </div>
                            <div class="value" style="width:890px">
                                <el-input v-model="surveyDataInfo.cConcRst" placeholder="" size="small" type="textarea" :rows="8"></el-input>
                            </div>
                        </div>
                        
                        <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                            <div class="label">
                                拒赔原因
                            </div>
                            <div class="value" style="width:890px">
                                <el-input v-model="surveyDataInfo.cRefuseRsn" placeholder="" size="small" type="textarea" ></el-input>
                            </div>
                        </div>
                        <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                            <div class="label">
                                拒赔金额
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.nRefusePayAmt" placeholder="" size="small" type="number" ></el-input>
                            </div>
                        </div>
                        <div class="item" v-if="surveyDataInfo.cConclusion=='2'">
                            <div class="label">
                                减损金额
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.nDeroAmt" placeholder="" size="small" type="number" ></el-input>
                            </div>
                        </div>
                        <!-- <div class="item" v-if="surveyDataInfo.cConclusion!=1">
                            <div class="label">
                                奖励费用
                            </div>
                            <div class="value">
                                <el-input v-model="editTaskFeeData.rewardFee" placeholder="" size="small" type="number" ></el-input>
                            </div>
                        </div> -->


                        <div class="item">
                            <div class="label">
                                是否大案疑案
                            </div>
                            <div class="value" style="width:500px">
                                <el-select v-model="surveyDataInfo.isbdCase" size="small" placeholder="请选择" @change="isBigCaseChange">
                                    <el-option
                                    v-for="item in isBigList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <el-select v-model="surveyDataInfo.bdCaseType" size="small" placeholder="请选择" style="margin-left:10px" v-if="this.surveyDataInfo.isbdCase">
                                    <el-option
                                    v-for="item in isBigStrList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                       
                        <div class="item">
                            <div class="label">
                                案件类型
                            </div>
                            <div class="value">
                                <el-input v-model="cSvyModeData.cSvyMode" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                预估赔付金额是否大于5万
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.isFive" size="small" placeholder="请选择" @change="isBigCaseChange">
                                    <el-option
                                    v-for="item in isFiveList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                案件完成时间
                            </div>
                            <div class="value">
                                <el-input v-model="cSvyModeData.cSvyMode" placeholder="请输入" size="small" disabled></el-input>
                            </div>
                        </div>
                        
                        <div class="tip">
                            {{isBigCase?"注意：该案件符合大案疑案条件，回销后由总部审核，案件审核通过后自动回销。":'注意：该案件不符合大案疑案条件，回销案件后案件即完成。'}}
                        </div>
                        <div class="item"> 
                            <el-button type="primary" icon="el-icon-edit" @click="updateCccnn" v-if="stepsActive==2||stepsActive==1||stepsActive==3||stepsActive==5">确认修改</el-button>
                        </div>
                    </div>
                    <div class="section">
                        <div class="title">
                            保司审核信息
                        </div>
                        <div class="item">
                            <div class="label">
                                保司审核状态
                            </div>
                            <div class="value">
                                <el-select v-model="surveyDataInfo.auditResult" size="small" placeholder="请选择" disabled>
                                    <el-option
                                    v-for="item in auditResultList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="label">
                                审核备注
                            </div>
                            <div class="value" style="width:590px">
                                <el-input v-model="surveyDataInfo.backReason" placeholder="" size="small" type="textarea" disabled></el-input>
                            </div>
                        </div>
                    </div>
                    
                    <div class="section">
                        <div class="title">
                            结案信息
                        </div>
                        <div class="item">
                            <div class="label">
                                赔付结论
                            </div>
                            <div class="value" style="width:590px">
                                <el-input v-model="surveyDataInfo.claimResultStr" placeholder="" size="small" type="textarea" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                实际赔付金额
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.actualAmount" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                减损金额
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.derogationAmount" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">
                                约定赔付金额
                            </div>
                            <div class="value">
                                <el-input v-model="surveyDataInfo.agreedAmount" placeholder="" size="small" disabled></el-input>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </el-tab-pane>
            <el-tab-pane label="案件日志">
                <el-button type="primary" style="margin-bottom: 10px;" @click="isLogDialog = true">点击添加日志操作记录</el-button>
                <div :style="height+';overflow-y: scroll;'">
                    <div style="width:100%">
                        
                        <el-table
                            :data="logList"
                            border
                            :header-cell-style="tableHeaderColor"
                            style="width: 100%">
                            <el-table-column
                            type="index"
                            width="80"
                            label="序号"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="operator"
                            label="操作人"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="content"
                            label="操作内容"
                            align="center"
                            >
                            </el-table-column>
                            <el-table-column
                            prop="creationTime"
                            label="操作时间"
                            align="center"
                            width="250px"
                            >
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        
        <!-- <div class="btns" v-if="detailData.taskSate == 20 ||detailData.taskSate == 30">
            <el-button type="primary" icon="el-icon-edit" @click="edit">确认编辑</el-button>
            <el-button type="success" icon="el-icon-edit" @click="examineTask">提交审核</el-button>
        </div> -->

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDoubtCourse" title="添加调查节点" width="800px">
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div class="item">
                    <div class="label">
                        调查节点
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.dcTaskSubJect" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addDoubtCourse.tCourTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        调查省级市
                    </div>
                    <div class="value">
                        <el-cascader
                        size="small"
                        :options="options"
                        v-model="selectedOptions"
                        @change="handleRegionChange">
                        </el-cascader>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPlace" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourPlaceList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        调查项目
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourPro" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourProList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourMode" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in CCourModeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        被调查人姓名
                    </div>
                    <div class="value">
                        <el-input v-model="addDoubtCourse.cCourOperNme" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.sourceType==2">
                    <div class="label">
                        被调查人与被保人关系
                    </div>
                    <div class="value">
                        <el-select v-model="addDoubtCourse.cCourRela" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in cCourRelaList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查过程
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="addDoubtCourse.cProcess" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>
               
            </div>
            <div class="btns">
                <el-button type="primary" icon="el-icon-zoom-in" @click="addDoubtCourseF">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddCaseMaterial" title="添加资料" width="800px">
           
            <div class="item">
                <div class="label">
                    资料名称
                </div>
                <div class="value">
                    <el-input v-model="addCaseMaterial.name" size="small" placeholder="请输入" style="width:300px"></el-input>
                </div>
            </div>
            <div class="item">
                <div class="label">
                    单证资料
                </div>
                <div class="value">
                    <el-upload
                        :action="uploadUrl"
                        multiple
                        :show-file-list="false"
                        :http-request="uploadCPath"
                        >
                        <el-button icon="el-icon-upload2" type="primary" size="small">上传资料</el-button>
                    </el-upload>

                    <el-button type="primary" icon="el-icon-download" size="small" @click="download(addCaseMaterial.path,addCaseMaterial.name)" style="margin-left:20px" v-if="addCaseMaterial.path">下载</el-button>
                </div>
            </div>
               
            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="addCaseMaterialF">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="surveyDataItemDialog" title="调查信息详情" width="800px">
            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="item">
                    <div class="label">
                        调查需求
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="surveyDataItem.cSvyNeed" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        调查需求编码
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyNeedCode" placeholder="请输入" size="small"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        期望完成时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.tHopeEndTm"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        疑案类型
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyType" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        案件类型
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyMode" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地点
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyPlace" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查地址
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataItem.cSvyAddr" placeholder="请输入" size="small"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        创建时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="surveyDataItem.creationTime"
                        type="datetime"
                        size="small"
                        class="citem-input"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        调查内容
                    </div>
                    <div class="value" style="width:590px">
                        <el-input v-model="assignData.cDoubtOpin" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div> -->
               
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isMechanismDialog" title="选择机构" width="800px">
            <el-table
            ref="multipleTable"
            :data="mechanismList"
            border
            :header-cell-style="tableHeaderColor"
            @selection-change="handleSelectionMechanismChange"
            style="width:100%"
            height="400px"
            >
            <el-table-column
            type="selection"
            align="center"
            width="55">
            </el-table-column>
            <el-table-column
            type="index"
            label="序号"
            width="60"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="name"
            label="机构名称"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="code"
            label="所在地区"
            align="center"
            >
            <template slot-scope="scope">
                {{scope.row.province}}
                {{scope.row.city}}
                {{scope.row.district}}
            </template>

            </el-table-column>
            
            </el-table>
            <div class="footer" style="margin-top:20px">
                <el-button icon="el-icon-circle-close" @click="isMechanismDialog=false">关 闭</el-button>
                <el-button type="primary" @click="affirmMechanism" icon="el-icon-edit-outline">确 定</el-button>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isAssignPerson" title="指派人员" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        人员：
                    </div>
                    <div class="value" style="width:300px">
                        <el-input v-model="assignPersonData.operator" placeholder="请输入" size="small" disabled></el-input>
                        <el-button type="primary" size="small" icon="el-icon-edit-outline" @click="userDialog = true">选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查要求：
                    </div>
                    <div class="value" style="width:500px">
                        <el-input v-model="assignPersonData.dcyq" placeholder="请输入" size="small" type="textarea"></el-input>
                    </div>
                </div>

                <!-- <div class="item" v-if="zpjg">
                    <el-checkbox v-model="assignPersonData.isZhuPai">主案人员</el-checkbox>
                </div> -->

                <div class="dialog-btn">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="affirmPerson">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="userDialog" title="选择人员" width="600px">
            <div class="condition">
                <div class="item">
                    <div class="label">人员名称:</div>
                    <el-input v-model="userConditionData.name" size="small" placeholder="请输入"></el-input>
                </div>
                <el-button type="primary" size="small" @click="selectUserData()">查询</el-button>
                <el-button type="warning" size="small" @click="resetUser()">重置</el-button>
            </div>
            <div class="table">
                <el-table
                    :data="userList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    
                    <el-table-column
                    prop="name"
                    label="用户名称"
                    align="center"
                    >
                    </el-table-column>
                    
                    <el-table-column
                    prop="roleNames"
                    label="关联角色"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" icon="el-icon-circle-check" @click="selectPerson(scope.row)">确认指派</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleCurrentChangeUser"
                        background
                        layout="prev, pager, next, total"
                        :total="userTotalCount"
                        :current-page="userConditionData.page"
                        :page-size="userConditionData.pageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog
            title="调查过程"
            :visible.sync="cProcessDetailDialog"
            width="600px"
            :modal="false"
            v-dialogDrag
            >
            <el-input
            placeholder="请输入内容"
            v-model="cProcess"
            type="textarea"
            :rows="20"
            >
            </el-input>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAuditBackDialog" title="审核退回" width="800px">
           
            <div class="item">
                <div class="label">
                    审核退回原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="taskReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="returnDoubtTaskItem">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isReturnReasonDialog" title="审核退回" width="800px">
           
            <div class="item">
                <div class="label">
                    审核退回原因
                </div>
                <div class="value" style="width:590px">
                    <el-input v-model="returnReason" placeholder="请输入" size="small" type="textarea"></el-input>
                </div>
            </div>
               
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" icon="el-icon-edit" @click="noAuditApi">确认</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isInfoDialog" title="查看调查过程" width="1500px" top="20px">
            
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isPersonInfoDialog" title="查看调查员资料" width="1500px" top="20px">
            
            <div class="section">
                <div class="title">
                    调查要求
                </div>
                <div class="item">
                    <div class="value" style="width:590px">
                        <el-input v-model="personDcyq" placeholder="请输入" size="small" type="textarea" rows="4" disabled></el-input>
                    </div>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查过程
                </div>
                <div style="margin:0 10px;width:100%">
                    <el-table
                        :data="personDoubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="dcTaskSubJect"
                        label="调查节点"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        prop="cCourAddr"
                        label="调查地址"
                        align="center"
                        >
                        </el-table-column> -->
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="section">
                <div class="title">
                    调查资料
                </div>
                <div style="margin:0 10px;width:100%">
                    <div class="section-item" v-for="(mitem,mindex) in personMaterialList" :key="mindex">
                        <div class="stitle">{{mitem[0].name}}</div>
                        <div class="materiallist">
                            <div class="material" v-for="(item,index) in mitem" :key="index">
                                <img src="../../../assets/images/icon11.png" alt="" v-if="item.fileType=='mp3'||item.fileType=='aac'||item.fileType=='wav'||item.fileType=='wma'||item.fileType=='flac'||item.fileType=='ape'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon12.png" alt="" v-else-if="item.fileType=='rmvb'||item.fileType=='rm'||item.fileType=='ts'||item.fileType=='tp'||item.fileType=='avi'||item.fileType=='3gp'||item.fileType=='mp4'||item.fileType=='mkv'" :fit="cover" @click="download(item.path,item.name)">
                                <img src="../../../assets/images/icon13.png" alt="" v-else-if="item.fileType=='xls'||item.fileType=='xlsx'||item.fileType=='doc'||item.fileType=='docx'||item.fileType=='ppt'||item.fileType=='pptx'||item.fileType=='pdf'||item.fileType=='zip'||item.fileType=='rar'" :fit="cover" @click="download(item.path,item.name)">
                                <el-image
                                style="width: 120px; height: 120px"
                                :src="item.path+'?x-oss-process=image/resize,w_200'"
                                v-else
                                @click="showImg(item.path,mitem)"
                                :fit="cover"></el-image>
                                <div class="filename">{{item.fileName}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </el-dialog>


     


        


        
        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"

        />

        <el-dialog :close-on-click-modal="false" :visible.sync="isApplyDispatchTip" title="申请加派/延期" width="1200px">
            <!-- <el-input
            placeholder="请输入内容"
            v-model="applyDispatchData.jpyq"
            type="textarea"
            :rows="20"
            >
            </el-input> -->

            <div class="section">
                <div class="title">
                    调查信息
                </div>
                <div class="handle" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5" style="margin:0 10px;width:100%">
                    <div>
                        <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="doubtCourseAddTip()">添加调查节点</el-button>
                                <el-button type="primary" size="mini" @click="downFileAnXinDcTask">下载调查资料</el-button>
                    </div>
                </div>
                <div class="section-item" v-for="(mitem,mindex) in doubtCourseList" :key="mindex" style="margin:0 10px;margin-top:10px;width:100%">
                    <div class="stitle" >
                        <div>
                            {{mitem.operator}} <span>({{mitem.operatorMechanism}})</span>
                            <i class="el-icon-folder-opened" v-if="mitem.isOpen" @click="changeIsOpen(mindex)"></i>
                            <i class="el-icon-folder" v-else @click="changeIsOpen(mindex)"></i>
                        </div>
                        <div class="stitle-r">
                            {{mitem.executeAction==0?'待接收':''}} 
                            {{mitem.executeAction==10?'待派工':''}} 
                            {{mitem.executeAction==20?'调查中':''}} 
                            {{mitem.executeAction==25?'待审核':''}} 
                            {{mitem.executeAction==30?'已提交':''}} 
                            {{mitem.executeAction==40?'任务退回':''}} 
                            {{mitem.executeAction==50?'完成':''}} 
                        </div>
                        

                    </div>
                    <el-table
                        :data="mitem.doubtCourses"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        v-if="mitem.isOpen"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="dcTaskSubJect"
                        label="调查节点"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="section-item" style="margin:0 10px;margin-top:10px;width:100%">
                    <div class="stitle" >
                        <div>
                            其他
                            <i class="el-icon-folder-opened" v-if="isOtherDoubtCourseListOpen" @click="isOtherDoubtCourseListOpen = false"></i>
                            <i class="el-icon-folder" v-else @click="isOtherDoubtCourseListOpen = true"></i>
                        </div>
                    </div>
                    <el-table
                        :data="otherDoubtCourseList"
                        border
                        :header-cell-style="tableHeaderColor"
                        style="width:100%"
                        v-if="isOtherDoubtCourseListOpen"
                        >
                        <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="dcTaskSubJect"
                        label="调查节点"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="tCourTm"
                        label="调查时间"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourAddr"
                        label="调查省级市"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourPlace"
                        label="调查地点"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPlace==1">医院</span>
                            <span v-if="scope.row.cCourPlace==2">事故地</span>
                            <span v-if="scope.row.cCourPlace==3">常住地</span>
                            <span v-if="scope.row.cCourPlace==4">住宅</span>
                            <span v-if="scope.row.cCourPlace==5">就诊地</span>
                            <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourPro"
                        label="调查项目"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourPro==1">正面调查</span>
                            <span v-if="scope.row.cCourPro==2">基础调查</span>
                            <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                            <span v-if="scope.row.cCourPro==4">事故查勘</span>
                        </template>
                        </el-table-column>
                    
                        <el-table-column
                        prop="cCourMode"
                        label="案件类型"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourMode=='1'">全案</span>
                            <span v-if="scope.row.cCourMode=='2'">单点</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cCourOperNme"
                        label="被调查人姓名"
                        align="center"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="cCourRela"
                        label="被调查人与被保人关系"
                        align="center"
                        width="180px"
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.cCourRela=='601002'">子女</span>
                            <span v-if="scope.row.cCourRela=='601003'">父母</span>
                            <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                            <span v-if="scope.row.cCourRela=='601005'">本人</span>
                            <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                            <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                            <span v-if="scope.row.cCourRela=='601008'">其它</span>
                            <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                            <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                            <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                            <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                            <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                            <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                            <span v-if="scope.row.cCourRela=='601016'">未知</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        prop="cProcess"
                        label="调查过程"
                        align="center"
                        width="150px"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                            <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                        </template>
                        </el-table-column>
                        <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">删除</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="editCCourTip(scope)" v-if="stepsActive==1||stepsActive==2||stepsActive==3||stepsActive==5">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini" @click="detailCCour(scope)" v-else>查看详情</el-button>
                        </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>


            <div class="section">
                <div class="title">
                    调查结论
                </div>
                <div class="item">
                    <div class="label">
                        调查结论
                    </div>
                    <div class="value">
                        <el-select v-model="surveyDataInfo.cConclusion" size="small" placeholder="" >
                            <el-option
                            v-for="item in cConclusionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="surveyDataInfo.cConclusion" placeholder="" size="small" disabled></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        调查意见
                    </div>
                    <div class="value" style="width:890px">
                        <el-input v-model="surveyDataInfo.cConcRst" placeholder="" size="small" type="textarea" :rows="8"></el-input>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                    <div class="label">
                        拒赔原因
                    </div>
                    <div class="value" style="width:890px">
                        <el-input v-model="surveyDataInfo.cRefuseRsn" placeholder="" size="small" type="textarea" ></el-input>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.cConclusion=='3'">
                    <div class="label">
                        拒赔金额
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataInfo.nRefusePayAmt" placeholder="" size="small" type="number" ></el-input>
                    </div>
                </div>
                <div class="item" v-if="surveyDataInfo.cConclusion=='2'">
                    <div class="label">
                        减损金额
                    </div>
                    <div class="value">
                        <el-input v-model="surveyDataInfo.nDeroAmt" placeholder="" size="small" type="number" ></el-input>
                    </div>
                </div>

                <!-- <div class="item">
                    <div class="label">
                        奖励费用
                    </div>
                    <div class="value">
                        <el-input v-model="rewardFee" placeholder="" size="small" type="number" ></el-input>
                    </div>
                </div> -->
                <div class="item"> 
                    <el-button type="primary" icon="el-icon-edit" @click="updateCccnn" v-if="stepsActive==2||stepsActive==1||stepsActive==3||stepsActive==5">确认修改</el-button>
                </div>
            </div>

            <div class="btns">
                <el-button type="primary" icon="el-icon-edit" @click="applyDispatch">确认</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isCancelCaseDialog" title="请确认预估理赔金额" width="400px">
            <span>预估理赔金额是否大于5万？</span>
            <div class="btns" style="margin-top:20px">
                <el-button type="primary" @click="cancelCase(50,true)">是</el-button>
                <el-button type="danger" @click="cancelCase(50,false)">否</el-button>
            </div>
        </el-dialog>


        <el-dialog :close-on-click-modal="false" :visible.sync="isProductReportDialog" title="生成报告" width="1400px">
            <div class="product-report">1、请编辑用于生成调查报告的调查节点 <span>(不影响案件的调查节点，仅影响报告生成)</span> </div>
            <el-table
                :data="productReportTaskList"
                border
                :header-cell-style="tableHeaderColor"
                style="width:100%"
                >
                <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="dcTaskSubJect"
                label="调查节点"
                align="center"
                width="200px"
                >
                </el-table-column>
                <el-table-column
                prop="tCourTm"
                label="调查时间"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourAddr"
                label="调查省级市"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourPlace"
                label="调查地点"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourPlace==1">医院</span>
                    <span v-if="scope.row.cCourPlace==2">事故地</span>
                    <span v-if="scope.row.cCourPlace==3">常住地</span>
                    <span v-if="scope.row.cCourPlace==4">住宅</span>
                    <span v-if="scope.row.cCourPlace==5">就诊地</span>
                    <span v-if="scope.row.cCourPlace==6">事故处理政府职能部门</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cCourPro"
                label="调查项目"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourPro==1">正面调查</span>
                    <span v-if="scope.row.cCourPro==2">基础调查</span>
                    <span v-if="scope.row.cCourPro==3">医疗查勘</span>
                    <span v-if="scope.row.cCourPro==4">事故查勘</span>
                </template>
                </el-table-column>
            
                <el-table-column
                prop="cCourMode"
                label="案件类型"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourMode=='1'">全案</span>
                    <span v-if="scope.row.cCourMode=='2'">单点</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cCourOperNme"
                label="被调查人姓名"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="cCourRela"
                label="被调查人与被保人关系"
                align="center"
                width="180px"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.cCourRela=='601002'">子女</span>
                    <span v-if="scope.row.cCourRela=='601003'">父母</span>
                    <span v-if="scope.row.cCourRela=='601004'">配偶</span>
                    <span v-if="scope.row.cCourRela=='601005'">本人</span>
                    <span v-if="scope.row.cCourRela=='601006'">抚养</span>
                    <span v-if="scope.row.cCourRela=='601007'">扶养</span>
                    <span v-if="scope.row.cCourRela=='601008'">其它</span>
                    <span v-if="scope.row.cCourRela=='601009'">赡养</span>
                    <span v-if="scope.row.cCourRela=='601011'">雇主</span>
                    <span v-if="scope.row.cCourRela=='601012'">雇员</span>
                    <span v-if="scope.row.cCourRela=='601013'">监护人</span>
                    <span v-if="scope.row.cCourRela=='601014'">被监护人</span>
                    <span v-if="scope.row.cCourRela=='601015'">朋友</span>
                    <span v-if="scope.row.cCourRela=='601016'">未知</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="cProcess"
                label="调查过程"
                align="center"
                width="150px"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="cProcessDetail(scope.row.cProcess)" v-if="scope.row.cProcess">查看调查过程</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" v-else>暂无</el-button>
                </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="180px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="moveUp(scope)">上移</el-button>
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="moveDown(scope)">下移</el-button>
                        
                        <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCour(scope)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="product-report">2、请选择报告模板</div>
            <div class="product-report-radio">
                <el-radio v-model="productReportType" label="1">固定模板(PDF) - 安心财险</el-radio>
                <el-radio v-model="productReportType" label="3">通用模板(Word) - 通用于健康险、意外险、责任险的案件</el-radio>
                <el-radio v-model="productReportType" label="2">通用模板(Word) - 通用于意外险、责任险的单点代查勘案件</el-radio>
            </div>
            

            <div class="product-report-btn">
                <el-button type="primary" icon="el-icon-download" @click="getPDF">确认生成</el-button>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditTaskFeeTip" title="编辑作业机构信息" width="800px">
            <div class="section">
                <div class="item">
                    <div class="label">
                        公估费用
                    </div>
                    <div class="value">
                        <el-input v-model="editTaskFeeData.taskFee" size="small" placeholder="请输入" style="width:300px" type="number"></el-input>
                    </div>
                </div>
                <div class="item" v-if="editTaskFeeData.taskFee=='0'">
                    <div class="label">
                        公估费用为0原因
                    </div>
                    <div class="value">
                        <el-select v-model="editTaskFeeData.taskFeeReason" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in taskFeeReasonList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        奖励费用
                    </div>
                    <div class="value">
                        <el-input v-model="editTaskFeeData.rewardFee" size="small" placeholder="请输入" style="width:300px" type="number"></el-input>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        是否主派机构
                    </div>
                    <div class="value">
                        <el-select v-model="editTaskFeeData.isZhuPaiJiGou" size="small" placeholder="请选择" class="citem-input">
                            <el-option
                            v-for="item in isZhuPaiJiGouList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div> -->
                <div class="item" style="width:100%">
                    <div class="label">
                        调查要求
                    </div>
                    <div class="value" style="width:588px">
                        <el-input v-model="editTaskFeeData.dcyq" size="small" placeholder="请输入" type="textarea"></el-input>
                    </div>
                </div>
               
                <div class="btns">
                    <el-button type="primary" icon="el-icon-edit" @click="editTaskFee">确认</el-button>
                </div>
            </div>
           
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isLogDialog" title="新增日志记录" width="600px">
            <div class="dialog">
               
                <div class="item">
                    <div class="label">
                        操作内容
                    </div>
                    <div class="value" style="width: 100%;">
                        <el-input type="textarea" v-model="addlogInfo.context"  :rows="6"  placeholder="请输入操作内容"></el-input>
                    </div>
                </div>
              
                
                <div slot="footer" class="dialog-footer" style="flex-direction: row-reverse;display:flex">
                    <el-button type="primary" @click="addlogInfobut">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import { batchDownload,batchDownloadList } from "../../../utils/downZip";
import { regionData , CodeToText } from "element-china-area-data";
import { cCourPlaceList , cCourProList , cCourRelaList , CCourModeList,RefuseRsnList ,InsuredNoTypeList,isBigList,isBigStrList,isFiveList,DcTaskActionList,financeStateList} from "../../../assets/selectList/anxin";
import { parseTimeS , parseTimeD } from "../../../utils/index";
 import "../../../utils/dialog"
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import draggable from 'vuedraggable'
import Vue from 'vue'

export default {
    name: 'index',
    components:{
        ElImageViewer,
        draggable

    },
    watch: {
    },
    data () {
        return {
            tabVal:0,
            uploadUrl:'',
            InsuredNoTypeList:InsuredNoTypeList,
            cCourPlaceList:cCourPlaceList,
            cCourProList:cCourProList,
            cCourRelaList:cCourRelaList,
            CCourModeList:CCourModeList,
            financeStateList:financeStateList,

            isBigList:isBigList,
            isBigStrList:isBigStrList,
            isFiveList:isFiveList,

            isLogDialog:false,
            isAssignTask:false,
            detailData:{},
            isAddDoubtCourse:false,
            isAddCaseMaterial:false,
            addDoubtCourse:{},
            addCaseMaterial:{},
            options:regionData,
            selectedOptions:null,
            cConclusionList:[{
                label:'正常赔付',
                value:'1',
            },{
                label:'减损',
                value:'2',
            },{
                label:'拒赔',
                value:'3',
            }],
            auditResultList:[{
                label:'未知',
                value:0,
            },{
                label:'同意',
                value:1,
            },{
                label:'退回',
                value:2,
            }],
            surveyInfo:[],
            surveyData:[],
            assignData:{},

            fullscreenLoading: false,
            surveyData:[],
            surveyInfo:[],
            surveyDataItem:{},
            surveyDataItemDialog:false,

            mechanismList:[],
            isMechanismDialog:false,
            selectMechanismList:[],

            logList:[],
            stepsActive:0,


            userConditionData:{
                name:'',
                page:1,
                pageSize:10,
            },
            userList:[],
            userDialog:false,
            userTotalCount:0,
            personDetailData:{
                doubtCourseList:[],
            },
            personTaskList:[],
            doubTaskMaterialItems:[],
            doubtCourseList:[],

            cProcessDetailDialog:false,
            cProcess:'',
            addCaseMaterialList:[],
            materialList:[],
            operatorId:'',

            surveyDataInfo:{
                anXinDcTaskId:'',
                cConclusion:null,
                cConcRst:'',
                cRefuseRsn:'',
                nRefusePayAmt:null,
                nDeroAmt:null,
            },
            RefuseRsnList:RefuseRsnList,
            isAuditBackDialog:false,
            isReturnReasonDialog:false,
            auditBackData:{},
            taskReason:'',
            returnReason:'',
            showBigImg:false,
            showBigImgList:[],
            isComplete:false,
            otherJgList:[],
            isInfoDialog:false,
            

            assignPersonData:{},
            isAssignPerson:false,

            addlogInfo:{},


            isPersonInfoDialog:false,
            personDoubtCourseList:[],
            personMaterialList:[],
            personDcyq:'',

            cDoubtOpinList:[],
            dcyqList:[],
            cAccdntProList:[],
            height:'',
            isEditMaterialSort:false,

            // 修改资料分类名称
            isEditMaterialNameDialog:false,
            editMaterialNameData:{
                anXinDcTaskId: "",
                oldName: "",
                name: ""
            },

           

            allNum:0,
            finishNum:0,

            // 新增调查过程

            isApplyDispatchTip:false,
            applyDispatchData:{
                anXinDcTaskId:'',
                jpyq:'',
            },

            operatorList:[],
            doubtCourseList:[],
            otherDoubtCourseList:[],
            isOtherDoubtCourseListOpen:true,

            auditId:null,
            
            report:{},

            isCancelCaseDialog:false,
            isRolesCancel:false,

            isProductReportDialog:false,
            productReportTaskList:[],
            productReportType:"1",
            rewardFee:null,

            editTaskFeeData:{
                "doubtTaskId": "",
                "taskFee": 0,
                "rewardFee": 0,
                "taskFeeReason": '',
                "isZhuPaiJiGou": false,
                "dcyq": '',
                // "doubtTaskId": "",
                // "rewardFee": 0,
            },
            isZhuPaiJiGouList:[{
                label:'是',
                value:true,
            },{
                label:'否',
                value:false,
            }],
            cSvyModeData:{},


            DcTaskActionList:DcTaskActionList,

            isBigCase:false,

            myMechanismId:localStorage.getItem('mechanismid'),
            isEditTaskFeeTip:false,
            
            isDestroyCase:false,

            

        }
    },
    created(){
        
       
        

        
    },
    mounted(){

        this.queryMechanism();
        this.queryDoubtTaskById();
        this.queryUserByMechanismIds();
        this.checkZp();
        this.queryAnXinDcTaskByAnXinDcTaskId();

        this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
        this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
        this.queryMaterByAnXinDcTaskId();
    },
    methods:{
        moveUp(scope){
            let i = scope.$index;
            if(i == 0){
                this.$message({
                    type: 'error',
                    message: '已经是最上'
                });
                return;
            }
            let j = i-1;
            let rowStri = JSON.stringify(this.productReportTaskList[i]);
            let rowStrj = JSON.stringify(this.productReportTaskList[j]);

            // this.productReportTaskList[i] = JSON.parse(rowStrj);
            this.productReportTaskList[j] = JSON.parse(rowStri);
            Vue.set(this.productReportTaskList, i, JSON.parse(rowStrj))
            this.$message({
                type: 'success',
                message: '上移成功'
            });  
        },
        async addlogInfobut(){

if(this.addlogInfo.context==''){
    this.$message({
        type: 'warning',
        message: '请填写日志信息!'
    });
    return;
}

let res = await api.addloginfos({
    contents:this.addlogInfo.context,
    anXinDcTaskId:this.detailData.anXinDcTaskId,
});
if(res.data.code == '200'){
    this.addlogInfo.context=='';
    this.isLogDialog=false;
    this.queryAnXinOperationLogByDoubtTaskId();
    this.$message({
        type: 'success',
        message: '添加成功!'
    });
}

},
        moveDown(scope){
            let i = scope.$index;
            if((this.productReportTaskList.length-1) == i){
                this.$message({
                    type: 'error',
                    message: '已经是最下'
                });
                return;
            }
            let j = i+1;
            let rowStri = JSON.stringify(this.productReportTaskList[i]);
            let rowStrj = JSON.stringify(this.productReportTaskList[j]);
            this.productReportTaskList[j] = JSON.parse(rowStri);
            Vue.set(this.productReportTaskList, i, JSON.parse(rowStrj))
            this.$message({
                type: 'success',
                message: '下移成功'
            });  
        },
        deleteCour(scope){
            this.$confirm('将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.productReportTaskList.splice(scope.$index,1)
                this.$forceUpdate();
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除资料
        async deleteDoubTaskMaterialTip(id){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubTaskMaterial(id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteDoubTaskMaterial(id){
            let res = await api.deleteDoubTaskMaterial(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
                this.queryMaterByAnXinDcTaskId();
            }
        },
        async queryMaterByAnXinDcTaskId(){
            let res = await api.queryMaterByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            let resData = res.data.data;
            this.report = {};
            for(let index in resData){
                if(resData[index].name == '调查报告'){
                    this.report = resData[index];
                }
            }
        },
        // 实时获取宽高
        getHeight(){
            let _this = this;
            if(_this.stepsActive==3||_this.stepsActive==5){
                _this.height =  'height:'+(document.body.clientHeight-180)+'px';
                window.onresize = function(){
                    _this.height =  'height:'+(document.body.clientHeight-180)+'px';
                }
            }else{
                _this.height =  'height:'+(document.body.clientHeight-140)+'px';
                window.onresize = function(){
                    _this.height =  'height:'+(document.body.clientHeight-140)+'px';
                }
            }
            
        },
       
        handleRegionChange(){
            let e = this.selectedOptions;
            if(e[2]){
                this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]+'-'+CodeToText[e[0],e[1],e[2]]
            }else if(e[1]){
                this.addDoubtCourse.cCourAddr = CodeToText[e[0]]+'-'+CodeToText[e[0],e[1]]
            }
            this.addDoubtCourse.cCourAll=this.selectedOptions;
            for(let index in this.selectedOptions){
                this.addDoubtCourse.cCourAll[index] = parseInt(this.selectedOptions[index]);
            }
            console.log(this.addDoubtCourse);
        },
       
        
        // 新增资料分类——上传资料
        async addMaterialItem(file){
            console.log(file.file);
            if(this.addMaterialItemDataName==''){
                this.$message({
                    type: 'warning',
                    message: '名称不能为空!'
                });
                return;
            }
            this.allNum = this.allNum+1;
            let material = {
                fileType:'',
                fileName:'',
                name:'',
                path:'',
            };
            material.fileName = file.file.name;
            let fileTypeList = material.fileName.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.finishNum = this.finishNum+1;

            material.path = res;
            console.log(material);

            this.addMaterialItemData.materialItem.push(material);
        },
        
        
        // 图片生成pdf
        async getAccidentImg(list){
            let ImgList = [];
            console.log(list);
            for(let i in list.data){
                if(list.data[i].fileType=='jpg'||list.data[i].fileType=='png'||list.data[i].fileType=='gif'||list.data[i].fileType=='jpeg'||list.data[i].fileType=='JPG'||list.data[i].fileType=='PNG'||list.data[i].fileType=='GIF'||list.data[i].fileType=='JPEG'){
                    ImgList.push(list.data[i].path);
                }
            }
            let res = await api.imgToPdf({
                imgUrl:ImgList,
                anXinDcTaskId:this.detailData.anXinDcTaskId,
                name:list.key,
                fileName:list.key+'.pdf',
            });
            if(res.data.code=='200'){
                 this.$message({
                    type: 'success',
                    message: '生成成功!'
                });
            }
            
        },
        // 查看编辑过程
        editCCour(row){
            console.log(row);
            localStorage.setItem('CCour',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:true,
                    anXinDcTaskId:row.anXinDcTaskId,
                    doubtTaskItemId:row.doubtTaskItemId,
                }
            });
            window.open(href, '_blank');
        },
        // 删除调查过程
        deleteCCourAll(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCCourAllApi(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCCourAllApi(row){
            let res = await api.deleteDoubtCourseList({
                id:row.id,
                doubtTaskItemId:row.doubtTaskItemId,
            });
            if(res.data.code='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });   
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            }
           
        },
        
        
      
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        showImg(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].fileType=='jpg'||list[i].fileType=='png'||list[i].fileType=='gif'||list[i].fileType=='jpeg'||list[i].fileType=='JPG'||list[i].fileType=='PNG'||list[i].fileType=='GIF'||list[i].fileType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        showImgm(img,list){
            let imglist = [];
            for(let i in list){
                if(list[i].materialType=='jpg'||list[i].materialType=='png'||list[i].materialType=='gif'||list[i].materialType=='jpeg'||list[i].materialType=='JPG'||list[i].materialType=='PNG'||list[i].materialType=='GIF'||list[i].materialType=='JPEG'){
                    imglist.push(list[i].path);
                    if(img==list[i].path){
                        this.imgIndex = imglist.length-1
                    }
                }
            }
            console.log(this.imgIndex);

            this.showBigImgList = imglist;
            this.showBigImg = true;
        },
        // 查询调查员列表
        async queryUserByMechanismIds(){
            // let operatorMechanismId = null;
            // if(this.assignJobAgenciesData.operatorMechanismId){
            //     operatorMechanismId = this.assignJobAgenciesData.operatorMechanismId;
            // }else if(this.dispatchDoubtTasks.operatorMechanismId&&this.dispatchDoubtTasks.operatorMechanismId){
            //     operatorMechanismId = this.dispatchDoubtTasks.operatorMechanismId;
            // }else{
            //     this.$message({
            //         type: 'error',
            //         message: '未选择机构!'
            //     });  
            //     return
            // }
            this.userConditionData.MechanismIds = [localStorage.getItem('mechanismid')]
            let res = await api.QueryUsers(this.userConditionData);
            if(res.data.data){
                // this.userDialog = true;
                this.userList = res.data.data.data;
                this.userTotalCount = res.data.data.totalCount;
            }
            // let res  = await api.queryUserByMechanismIds(this.userConditionData);
            // this.userList = res.data.data.data;
            // this.userTotalCount = res.data.data.totalCount;
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
         // 机构列表
        async queryMechanism(){
            let res = await api.QueryMechanism();
            this.mechanismList = res.data.data.data;
        },
        changeTab(e){
            if(e.index==0){
                this.queryDoubtTaskById();
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            }
            if(e.index==1){
                this.queryAnXinDoubtDetailByAnXinDcTaskId();
                this.queryAnXinCaseMaterialItemByAnXinDcTaskId();
            }
           
            if(e.index==2){
                this.queryDoubtTaskItemByDoubtTaskId();
                this.queryDoubtTasksByAnXinDcTaskId();
            }
            
            if(e.index==3){
                this.queryAnXinOperationLogByDoubtTaskId();
            }
        },
        
        async queryDoubtTasksByAnXinDcTaskId(){
            let res = await api.queryDoubtTasksByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.otherJgList = res.data.data;
        },
        // 调查信息
        async queryDoubtTaskItem_CourseByAnXinDcTaskId(){
            let res = await api.queryDoubtTaskItem_CourseByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            if(res.data.code == '200'){
                this.doubtCourseList = res.data.data;
            }
        },
        async queryByAnXinDcTaskIdExcludeDoubtTaskItem(){
            let res = await api.queryByAnXinDcTaskIdExcludeDoubtTaskItem(this.$route.query.anXinDcTaskId);
            if(res.data.code == '200'){
                this.otherDoubtCourseList = res.data.data;
            }
        },
       
        
       
        // 调查任务Id查询调查资料
        async queryAnXinCaseMaterialItemByAnXinDcTaskId(){
            let res = await api.queryAnXinCaseMaterialItemByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.surveyInfo = res.data.data;
        },
        // 调查任务Id查询调查信息
        async queryAnXinDoubtDetailByAnXinDcTaskId(){
            let res = await api.queryAnXinDoubtDetailByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.surveyData = res.data.data;
        },
        
        async queryDoubtTaskItemByDoubtTaskId(){
            let res = await api.queryDoubtTaskItemByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.personTaskList = res.data.data;
        },
        // 作业机构
        async queryDoubtTaskByAnXinDcTaskId(){
            let res = await api.queryDoubtTaskByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.detailData=res.data.data;
            if(!this.detailData.doubTaskMaterialItems){
                this.detailData.doubTaskMaterialItems = [];
            }
            if(!this.detailData.doubtCourseList){
                this.detailData.doubtCourseList = [];
            }
        },
        // 日志
        async queryAnXinOperationLogByDoubtTaskId(){
            let res = await api.queryAnXinOperationLogByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.logList=res.data.data;
        },
        // 调查信息详情
        surveyDataDetail(row){
            console.log(row);
            this.surveyDataItemDialog = true;
            this.surveyDataItem = row;
        },
        // 调查资料下载
        async downFileAnXinDcTask(){
            let res = await api.downFileAnXinDcTask(this.detailData.anXinDcTaskId,{
                zipName:'调查资料'
            });
            // let res = await api.jsDownFileAnXinDcTask(this.detailData.anXinDcTaskId);
            // if(res.data.code == '200'){
            //     batchDownloadList(res.data.data)
            // }
        },
        async downloadSurveyInfo(){
            // let res = await api.downFileAnXinPgDcTask(this.detailData.anXinDcTaskId,{
            //     zipName:'派工资料'
            // });
            for(let i in this.surveyInfo){
                let pathList = this.surveyInfo[i].path.split('.');
                if(pathList.length==1){
                    this.surveyInfo[i].path = this.surveyInfo[i].path+'.'+this.surveyInfo[i].materialType
                }
                
            }
            batchDownload(this.surveyInfo)
        },
        // 指派机构
        async affirmMechanism(){
            console.log(this.selectMechanismList);
            console.log(this.detailData);
            let option = [];
            for(let i in this.selectMechanismList){
                
                option.push({
                    anXinDcTaskId:this.detailData.id,
                    cDoubtId:this.detailData.cDoubtId,
                    operatorMechanism:this.selectMechanismList[i].name,
                    operatorMechanismId:this.selectMechanismList[i].id,
                    CClmNo:this.detailData.cClmNo,
                    CPlyNo:this.detailData.cPlyNo,
                    CInsuredNme:this.detailData.cInsuredNme,
                })
                
            }
            let res = await api.batchDispatchTaskToOperatorMechanism({
                AnXinDcTaskId:this.detailData.id,
                doubtTaskRequest:option
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '指派成功!'
                });
                this.isMechanismDialog=false;
                this.queryDoubtTaskByAnXinDcTaskId(this.detailData.id);
            }
        },
        // 选择机构
        handleSelectionMechanismChange(e){
            this.selectMechanismList = e;
        },
        // 取消指派
        async cancelAssign(row){
            this.$confirm('将取消指派，是否确认?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteDoubtTaskItem(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        // 退回人员任务
        async backTask(row){
            this.backTaskId = row.id
            this.isAuditBackDialog = true;
        },
        async returnDoubtTaskItem(){
            let res = await api.returnDoubtTaskItem({
                doubtTaskItemId:this.backTaskId,
                taskReason:this.taskReason,
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已退回成功'
                });  
                this.isAuditBackDialog = false;
                this.taskReason = '';
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
        async deleteDoubtTaskItem(id){
            let res = await api.deleteDoubtTaskItem(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '已取消成功'
                });  
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
        // 接受任务
        receiveDoubtTaskTip(){
            this.$confirm('确认接受任务, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.receiveDoubtTask();
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });          
            });
        },
        async receiveDoubtTask(){
            // return;
            let res = await api.receiveDoubtTask({
                id:this.$route.query.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '接受成功'
                });  
                this.tabVal = '2';
                this.$confirm('请指派调查员。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                   
                }).catch(() => {
                      
                });
                this.queryDoubtTaskById();
                // this.queryDoubtTaskByAnXinDcTaskId();
            }
        },
        
       
        assignPersonTip(){
            this.assignPersonData.cDoubtId = this.detailData.cDoubtId;
            this.assignPersonData.cClmNo = this.detailData.cClmNo;
            this.assignPersonData.cPlyNo = this.detailData.cPlyNo;
            this.assignPersonData.cInsuredNme = this.detailData.cInsuredNme;
            this.assignPersonData.cProdName = this.detailData.cProdName;
            this.isAssignPerson = true;
        },

        async selectPerson(row){
            this.assignPersonData.doubtTaskId = this.$route.query.id;
            this.assignPersonData.operator = row.name;
            this.assignPersonData.operatorId = row.id;
            this.userDialog = false;
        },
        async affirmPerson(){
            let res = await api.assignTaskToOperator(this.assignPersonData);
            if(res.data.code == '200') {
                this.$message({
                    message: '指派成功',
                    type: 'success'
                });
                this.isAssignPerson = false;
                this.assignPersonData.operator = '';
                this.assignPersonData.operatorId = null;
                this.assignPersonData.dcyq = '';
                this.queryDoubtTaskById();
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },
       

        handleCurrentChangeUser(page){
            this.userConditionData.page = page;
            this.queryUserByMechanismIds();
        },
        selectUserData(){
            this.userConditionData.page = 1;
            this.queryUserByMechanismIds();
        },
        resetUser(){
            this.userConditionData.name = "";
            this.userConditionData.page = 1;
            this.queryUserByMechanismIds();
        },

        // 调查过程
        doubtCourseAddTip(){
            this.isAddDoubtCourse = true;
        },
        // 添加调查节点成功
        async addDoubtCourseF(){
            if(!this.addDoubtCourse.dcTaskSubJect){
                this.$message({
                    type: 'warning',
                    message: '调查节点不能为空!'
                });
                return;
            }
            // if(!this.addDoubtCourse.cCourAddr){
            //     this.$message({
            //         type: 'warning',
            //         message: '调查省级市不能为空!'
            //     });
            //     return;
            // }
            // if(!this.addDoubtCourse.cCourMode){
            //     this.$message({
            //         type: 'warning',
            //         message: '案件类型不能为空!'
            //     });
            //     return;
            // }
            // if(!this.addDoubtCourse.cCourOperNme){
            //     this.$message({
            //         type: 'warning',
            //         message: '被调查人姓名不能为空!'
            //     });
            //     return;
            // }
            // if(!this.addDoubtCourse.cCourPlace){
            //     this.$message({
            //         type: 'warning',
            //         message: '调查地点不能为空!'
            //     });
            //     return;
            // }
            // if(!this.addDoubtCourse.cCourPro){
            //     this.$message({
            //         type: 'warning',
            //         message: '调查项目不能为空!'
            //     });
            //     return;
            // }
            // if(!this.addDoubtCourse.cCourRela){
            //     this.$message({
            //         type: 'warning',
            //         message: '被调查人与被保人关系不能为空!'
            //     });
            //     return;
            // }
            if(!this.addDoubtCourse.cProcess){
                this.$message({
                    type: 'warning',
                    message: '调查过程不能为空!'
                });
                return;
            }
            if(!this.addDoubtCourse.tCourTm){
                this.$message({
                    type: 'warning',
                    message: '调查时间不能为空!'
                });
                return;
            }
            this.addDoubtCourse.tCourTm = parseTimeS(this.addDoubtCourse.tCourTm);
            // this.addDoubtCourse.doubtTaskItemId	= this.$route.query.id;
            this.addDoubtCourse.anXinDcTaskId = this.detailData.anXinDcTaskId;
            let res = await api.doubtCourseAddRange([this.addDoubtCourse]);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.addDoubtCourse = {
                    cCourAddr:null,
                    cCourAll:null,
                    cCourMode:null,
                    cCourOperNme:null,
                    cCourPlace:null,
                    cCourPro:null,
                    cCourRela:null,
                    cProcess:null,
                    tCourTm:null,
                };
                this.selectedOptions = null;
                this.isAddDoubtCourse = false;
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            }
        },
        deleteCCourTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteCCour(id){
            let res = await api.doubtCourseDelete(id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
                this.queryByAnXinDcTaskIdExcludeDoubtTaskItem();
            } 
        },
        // 调查任务Id查询调查信息
        async queryDoubtTaskById(){
            let res = await api.queryDoubtTaskById(this.$route.query.id);
            this.detailData = res.data.data;
            
            

            this.detailData.doubtCourseList = this.detailData.doubtCourseList?this.detailData.doubtCourseList:[];
            this.detailData.doubTaskMaterialItems = this.detailData.doubTaskMaterialItems?this.detailData.doubTaskMaterialItems:[];

            if(this.detailData.dcyq){
                 this.dcyqList = this.detailData.dcyq.split(/\n/g);
            }

            for(let index in this.detailData.doubtCourseList){
                let cCourAll = this.detailData.doubtCourseList[index].cCourAll.split('-');
            }
            if(this.detailData.executeAction==0){
                this.stepsActive = 0;
            }
            else if(this.detailData.executeAction==10){
                this.stepsActive = 1;
            }
            else if(this.detailData.executeAction==20){
                this.stepsActive = 2;
            }
            else if(this.detailData.executeAction==25){
                this.stepsActive = 3;
            }
            else if(this.detailData.executeAction==30){
                this.stepsActive = 4;
            }
            else if(this.detailData.executeAction==40){
                this.stepsActive = 5;
            }
            else if(this.detailData.executeAction==50){
                this.stepsActive = 6;
            }else if(this.detailData.executeAction==70){
                this.stepsActive = 7;
            }
            this.getHeight();
        },
        // 确认编辑
        async edit(){
            this.detailData.nRefusePayAmt = parseFloat(this.detailData.nRefusePayAmt);
            this.detailData.nDeroAmt = parseFloat(this.detailData.nDeroAmt);
            let res = await api.updateTaskInfo(this.detailData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
        },
        // 提交审核
        async examineTask(){
            let res = await api.updateTaskInfo(this.detailData);
            if(res.data.code == '200'){
                this.examineTaskApi();
            }
        },
        async examineTaskApi(){
            let option = {
                id:this.$route.query.id,
                taskSate:40
            };
            let res  = await api.examineTask(option);
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
            }
            this.queryDoubtTaskById();
        },
        
        // 上传
        async uploadCPath(file){
            let name = file.file.name;
            let fileTypeList = name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            this.addCaseMaterial.fileType = fileType;
            let res = await api.uploadOther(file.file);
            this.addCaseMaterial.path = res;
            this.$forceUpdate();
            console.log(res);

        },
        // 添加调查资产
        addCaseMaterialF(){
            this.detailData.doubTaskMaterialItems.push(this.addCaseMaterial);
            this.isAddCaseMaterial = false;
            console.log(this.detailData.doubTaskMaterialItems);
            this.$forceUpdate();
        },
        // 下载资料
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        deleteDoubTaskMaterialItemTip(scope){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.deleteCCour(scope.$index);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        deleteDoubTaskMaterialItem(index){
            this.detailData.doubTaskMaterialItems.splice(index,1);
            this.$message({
                type: 'success',
                message: '已删除成功'
            });   
        },
        // 提交审核
        auditTip(item){
            this.$confirm('确认审核通过?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
               this.audit(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async audit(item){
            let option = {
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
                id:item.id,
                executeAction:30,
            };
            let res = await api.updateExecuteAction(option);
            if(res.data.code == 200){
                this.$message({
                    type: 'success',
                    message: '审核成功'
                }); 
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
            }
        },
        // async audit(){
        //     let option = {
        //         anXinDcTaskId:this.$route.query.anXinDcTaskId,
        //         doubtTaskId:this.$route.query.id
        //     };
        //     let res = await api.updateAuditStatusDoubtTask(option);
        //     if(res.data.code == 200){
        //         this.$message({
        //             type: 'success',
        //             message: '提交审核成功'
        //         }); 
        //         this.queryDoubtTaskById();
        //     }
        // },
        
        async noAudit(item){
            this.auditId = item.id
            this.isReturnReasonDialog = true;
        },
        async noAuditApi(){
            let res = await api.returnDoubtTaskItem({
                "doubtTaskItemId": this.auditId,
                "taskReason": this.returnReason
            });
            if(res.data.code == '200') {
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.returnReason = false;
                this.isReturnReasonDialog = false;
                this.queryDoubtTaskItem_CourseByAnXinDcTaskId();
            }
        },
        // async uploadFile(){
        //     let res = await api.uploadFile({
        //         id:this.$route.query.id,
        //     });
        //     console.log(res);
        // },
        


        
    

        async cProcessDetail(detail){
            console.log(detail);
            this.cProcess = detail;
            this.cProcessDetailDialog = true;
        },
        async checkZp(){
            let res = await api.checkZp({anXinDcTaskId:this.$route.query.anXinDcTaskId});
            this.zpjg = res.data.data.zpjg;
            this.operatorId = res.data.data._operatorId;
        },

        async setZhuPaiOperator(row){
            console.log(row);
            let res = await api.setZhuPaiOperator({
                id:row.id
            });
            if(res.data.code == '200') {
                this.$message({
                    message: '设置成功',
                    type: 'success'
                });
                this.queryDoubtTaskItemByDoubtTaskId();
            }
        },

        // 查询调查信息
        async queryAnXinDcTaskByAnXinDcTaskId(){
            let res = await api.queryAnXinDcTaskByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.surveyDataInfo=res.data.data;
            if(this.surveyDataInfo.cDoubtOpin){
                this.cDoubtOpinList = this.surveyDataInfo.cDoubtOpin.split(/\n/g);
            }
            
            if(this.surveyDataInfo.cAccdntPro){
                this.cAccdntProList = this.surveyDataInfo.cAccdntPro.split(/\n/g);
            }
            document.title = '意健险——'+this.surveyDataInfo.cInsuredNme
        
            
            this.anXinDcTaskQueryCaseTypeByAnXinDcTaskId();
            if((localStorage.getItem('mechanism')=="广州天信保险公估有限公司广东分公司"||localStorage.getItem('mechanism')=="广州天信保险公估有限公司山东分公司")&&this.surveyDataInfo.companyName=="安心财产保险有限责任公司"){
                this.isDestroyCase = true;
            }else{
                this.isDestroyCase = false;
            }
            this.$forceUpdate();
        },
        // 人员
        async personDetail(row){
            this.isPersonInfoDialog = true;
            let res = await api.queryDoubtTaskItemById(row.id);
            let doubTaskMaterialItems = res.data.data.doubTaskMaterialItems;
            this.personDoubtCourseList = res.data.data.doubtCourseList;
            this.personDcyq = res.data.data.dcyq;
            let name = '';
            this.personMaterialList = [];
            for(let i in doubTaskMaterialItems){
                if(name!=doubTaskMaterialItems[i].name){
                    name = doubTaskMaterialItems[i].name;
                    this.personMaterialList.push([]);
                }   
                this.personMaterialList[this.personMaterialList.length-1].push(doubTaskMaterialItems[i]);
            }
        },
        // 编辑调查结论
        async updateCccnn(){
            if(!this.surveyDataInfo.isbdCase){
                this.surveyDataInfo.bdCaseType = ''
            }
            let res = await api.UpdateCccnn({
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
                cConclusion:this.surveyDataInfo.cConclusion,
                cConcRst:this.surveyDataInfo.cConcRst,
                cRefuseRsn:this.surveyDataInfo.cRefuseRsn,

                isbdCase:this.surveyDataInfo.isbdCase,
                bdCaseType:this.surveyDataInfo.bdCaseType,
                isFive:this.surveyDataInfo.isFive,

                nRefusePayAmt:parseFloat(this.surveyDataInfo.nRefusePayAmt?this.surveyDataInfo.nRefusePayAmt:0),
                nDeroAmt:parseFloat(this.surveyDataInfo.nDeroAmt?this.surveyDataInfo.nDeroAmt:0),
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
            }
                    
        },


        // 申请加派
        async applyDispatch(){
            if(this.doubtCourseList.length==0){
                this.$message({
                    type: 'warning',
                    message: '调查过程不能为空'
                }); 
                return;
            }
           
            this.applyDispatchData.anXinDcTaskId = this.detailData.anXinDcTaskId
            this.applyDispatchData.isJpyq = true;
            
            let res = await api.setDcTaskJpyq(this.applyDispatchData);
            if(res.data.code == '200'){
                
                this.audit();
                this.isApplyDispatchTip = false;
            }
        },


        // 获取调查员信息列表
        async querayDcTaskOperatorByAnXinDcTaskId(){
            let res = await api.querayDcTaskOperatorByAnXinDcTaskId(this.detailData.anXinDcTaskId);
            if(res.data.code == '200'){
                this.operatorList = res.data.data;
                this.isProductReportDialog = true;
            }
            this.productReportTaskList = [];
            for(let i in this.doubtCourseList){
                for(let j in this.doubtCourseList[i].doubtCourses){
                   this.productReportTaskList.push(this.doubtCourseList[i].doubtCourses[j]);
                }
            }
            for(let i in this.otherDoubtCourseList){
                   this.productReportTaskList.push(this.otherDoubtCourseList[i]);
            }
        },
         // 获取pdf
        async getPDF(){
            let investigatorList = [];
            for(let index in this.operatorList){
                if(index == 0){
                    investigatorList = this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
                }else{
                    investigatorList = investigatorList + '\r' + this.operatorList[index].operatorName + '\n' + this.operatorList[index].phone;
                }
            }

            let nowTime = parseTimeD(new Date());
            let investigation = [];

            // for(let i in this.doubtCourseList){
            //     for(let j in this.doubtCourseList[i].doubtCourses){
            //         let cProcess = this.doubtCourseList[i].doubtCourses[j].cProcess.replace(/[\n]/g, "\r\n\n");
            //         let num = (investigation.length) + 1;
            //         let tCourTm = parseTimeD(this.doubtCourseList[i].doubtCourses[j].tCourTm);
            //         investigation.push({
            //             title:'\n\n' +num+'、'+this.doubtCourseList[i].doubtCourses[j].dcTaskSubJect+'\r\n\n'+'调查时间：'+tCourTm,
            //             bodyStr:'调查过程：\r'+cProcess,
            //         })
            //     }
            // }
            // for(let i in this.otherDoubtCourseList){
            //     let cProcess = this.otherDoubtCourseList[i].cProcess.replace(/[\n]/g, "\r\n\n");
            //     let num = (investigation.length) + 1;
            //     let tCourTm = parseTimeD(this.otherDoubtCourseList[i].tCourTm);
            //     investigation.push({
            //         title:'\n\n' +num+'、'+this.otherDoubtCourseList[i].dcTaskSubJect+'\r\n\n'+'调查时间：'+tCourTm,
            //         bodyStr:'调查过程：\r'+cProcess,
            //     })
            // }

            let fileType = this.productReportType == '1'?'pdf':'doc'
            if(this.productReportType == '1'){
                for(let i in this.productReportTaskList){
                    let cProcess = this.productReportTaskList[i].cProcess.replace(/[\n]/g, "\r\n\n");
                    let num = (investigation.length) + 1;
                    let tCourTm = parseTimeD(this.productReportTaskList[i].tCourTm);
                    investigation.push({
                        title:'\n\n' +num+'、'+this.productReportTaskList[i].dcTaskSubJect+'\r\n\n'+'调查时间：'+tCourTm,
                        bodyStr:'调查过程：\r'+cProcess,
                    })
                }
            }else{
                for(let i in this.productReportTaskList){
                    let cProcess = this.productReportTaskList[i].cProcess.replace(/[\n]/g, "\r\n\n");
                    let num = (investigation.length) + 1;
                    investigation.push({
                        title:'\n\n' +num+'、'+this.productReportTaskList[i].dcTaskSubJect,
                        bodyStr:cProcess,
                    })
                }
            }
           

            // 调查经过
            let cAccdntPro = [];
            let cConcRstList = [];
            let cDoubtOpinList = [];
            if(this.surveyDataInfo.cAccdntPro){
                cAccdntPro = this.surveyDataInfo.cAccdntPro.replace(/[\r]/g, "");
                cAccdntPro = cAccdntPro.replace(/[\n]/g, "");
            }
            if(this.surveyDataInfo.cConcRst){
                cConcRstList = this.surveyDataInfo.cConcRst.replace(/[\r]/g, "");
                cConcRstList = cConcRstList.split(/\n/g);
            }

            if(this.surveyDataInfo.cDoubtOpin){
                cDoubtOpinList = this.surveyDataInfo.cDoubtOpin.replace(/[\r]/g, "");
                cDoubtOpinList = cDoubtOpinList.split(/\n/g);
            }


            let cConcRstProject1 = '';
            let cConcRstProject2 = '';
            let cDoubtOpinProject = '';

            for(let i in cConcRstList){
                cConcRstList[i] = cConcRstList[i].replace(/[\n]/g, "");
                if(i==0){
                    cConcRstProject1 = cConcRstList[i]
                    cConcRstProject2 = '\n\n'+ cConcRstList[i]
                }else{
                    cConcRstProject1 = cConcRstProject1 + '\r\n\n'+ cConcRstList[i]
                    cConcRstProject2 = cConcRstProject2 + '\r\n\n'+ cConcRstList[i]
                }
            }
            for(let i in cDoubtOpinList){
                cDoubtOpinList[i] = cDoubtOpinList[i].replace(/[\n]/g, "");
                if(i==0){
                    cDoubtOpinProject = cDoubtOpinList[i]
                }else{
                    cDoubtOpinProject = cDoubtOpinProject + '\r\n\n'+ cDoubtOpinList[i]
                }
            }
            console.log(this.surveyDataInfo);
            console.log("-----------------");
            let option = {
                "anXinDcTaskId":this.detailData.anXinDcTaskId,
                "no": this.operatorList[0].reportNo,
                "principalName": this.surveyDataInfo.companyName,
                "peoPleName": this.surveyDataInfo.cInsuredNme,
                "conclusion": cConcRstProject1,
                "reportGenerationTime": nowTime,
                "cxridcard": this.surveyDataInfo.cCertNo,
                "dcjl":  this.surveyDataInfo.cConclusion,
               "company": this.surveyDataInfo.companyName,
                "riskTyep": this.surveyDataInfo.cProdName,
                "insurePeople": "",
                "policyNo": this.surveyDataInfo.cPlyNo,
                "reportNo": this.surveyDataInfo.cClmNo,
                "outRiskTime": parseTimeD(this.surveyDataInfo.tAccdntTm),
                "outRiskPlace": this.surveyDataInfo.cAccdntPlace,
                "injuredName": "\n\n"+cAccdntPro,

                // "caseProfile":cAccdntPro,
                "caseProfile":(cAccdntPro&&cAccdntPro.length>0)?cAccdntPro:'',
                "entrustedProject": cDoubtOpinProject,
                "investigation": investigation,
                "conclusionInfo": cConcRstProject2,
                // "investigator": this.surveyDataInfo.zpOperator,//调查员
                "investigator": investigatorList,//调查员
                
                "template":parseFloat(this.productReportType),
                "dangerName":this.detailData.personDanger,

                "issue": localStorage.getItem('name'),//签发人
                "fileName":"调查报告——"+this.detailData.personDanger+'.'+fileType
            }
            console.log(option);
            let res = await api.getAccident(option);
            this.$message({
                type: 'success',
                message: '生成成功!'
            });
            this.isProductReportDialog = false;
            this.queryMaterByAnXinDcTaskId();

        },

        // 是否展开
        changeIsOpen(index){
            this.doubtCourseList[index].isOpen = this.doubtCourseList[index].isOpen==true?false:true;
            this.$forceUpdate();
        },
        // 编辑调查过程
        editCCourTip(scope){
            console.log(scope.row);
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:true,
                    anXinDcTaskId:this.detailData.anXinDcTaskId,
                    doubtTaskItemId:this.detailData.id,
                }
            });
            window.open(href, '_blank');
           
        },
        detailCCour(scope){
            const { href } = this.$router.resolve({
                name: "doubtCourseDetail",
                query:{
                    id:scope.row.id,
                    stepsActive:false,
                    anXinDcTaskId:this.detailData.anXinDcTaskId,
                    doubtTaskItemId:this.detailData.id,

                }
            });
            window.open(href, '_blank');
        },
        // 提交总部审核
        async submitAuditTip(){
            this.editConclusion();
            this.$confirm('确认提交总部审核？', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitAudit()

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        submitZyJgReviewTip(){
            this.editConclusion();
            this.$confirm('确认提交审核？', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitZyJgReview()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        
        async submitAudit(){
            
            for(let i in this.doubtCourseList){
                if(this.doubtCourseList[i].executeAction!=30&&this.doubtCourseList[i].executeAction!=50){
                    this.$message({
                        type: 'error',
                        message: '调查员未审核完成,不可提交!'
                    });
                    return;
                }
            }
            if(!this.surveyDataInfo.cConclusion){
                this.$message({
                    type: 'error',
                    message: '调查结论未填'
                });
                return;
            }
           
            let res = await api.submitForReview({
                executeAction:30,
                doubtTaskId:this.$route.query.id,
            });

            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.queryDoubtTaskById();
            }
            
        },
        async submitZyJgReview(){
            for(let i in this.doubtCourseList){
                if(this.doubtCourseList[i].executeAction!=30&&this.doubtCourseList[i].executeAction!=50){
                    this.$message({
                        type: 'error',
                        message: '调查员未审核完成,不可提交!'
                    });
                    return;
                }
            }
            if(!this.surveyDataInfo.cConclusion){
                this.$message({
                    type: 'error',
                    message: '调查结论未填'
                });
                return;
            }
           
            let res = await api.submitZyJgReview({
                executeAction:30,
                doubtTaskId:this.$route.query.id,
            });

            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.queryDoubtTaskById();
            }
        },
        async editConclusion(){



            if(!this.surveyDataInfo.isbdCase){
                this.surveyDataInfo.bdCaseType = ''
            }
            let res = await api.UpdateCccnn({
                anXinDcTaskId:this.$route.query.anXinDcTaskId,
                cConclusion:this.surveyDataInfo.cConclusion,
                cConcRst:this.surveyDataInfo.cConcRst,
                cRefuseRsn:this.surveyDataInfo.cRefuseRsn,

                isbdCase:this.surveyDataInfo.isbdCase,
                bdCaseType:this.surveyDataInfo.bdCaseType,
                isFive:this.surveyDataInfo.isFive,

                nRefusePayAmt:parseFloat(this.surveyDataInfo.nRefusePayAmt?this.surveyDataInfo.nRefusePayAmt:0),
                nDeroAmt:parseFloat(this.surveyDataInfo.nDeroAmt?this.surveyDataInfo.nDeroAmt:0),
            });
        },
        cancelCaseTip(){
            this.editConclusion();
            this.$confirm('将回销案件，是否继续？', '注意', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.cancelCase(50,this.surveyInfo.isFive);
            // this.updateCccnn();

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async cancelCase(status,bol){
            for(let i in this.doubtCourseList){
                if(this.doubtCourseList[i].executeAction!=30&&this.doubtCourseList[i].executeAction!=50){
                    this.$message({
                        type: 'error',
                        message: '调查员未审核完成,不可提交!'
                    });
                    return;
                }
            }
            if(!this.surveyDataInfo.cConclusion){
                this.$message({
                    type: 'error',
                    message: '调查结论未填'
                });
                return;
            }
            let res = await api.sellBack({
                executeAction:status,
                doubtTaskId:this.$route.query.id,
                IsFive:bol
            });

            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '操作成功!'
                });
                this.isCancelCaseDialog = false;
                this.queryDoubtTaskById();
            }
        },


        async uploadPDF(file){
            let fileTypeList = file.file.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            fileType = fileType.replace(/\s*/g,"");
            fileType = fileType.toLowerCase( );


            let res = await api.uploadOther(file.file);
            let path = res;
            let option = {
                fileType:fileType,
                fileName:file.file.name,
                anXinDcTaskId:this.detailData.anXinDcTaskId,
                path:path,
            };
            let data = await api.uploadDcTaskReport(option);
            if(data.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '上传成功!'
                });
            }
            this.queryMaterByAnXinDcTaskId();
            this.$forceUpdate();
        },


        async editTaskFee(){
            if(!this.editTaskFeeData.taskFee&&this.editTaskFeeData.taskFee!='0'){
                this.$message({
                    message: '公估费用未填！',
                    type: 'error'
                });
                return;
            }
            if(this.editTaskFeeData.taskFee == '0'){
                if(!this.editTaskFeeData.taskFeeReason){
                    this.$message({
                        message: '公估费用为0原因未填！',
                        type: 'error'
                    });
                    return;
                }
            }
            this.editTaskFeeData.rewardFee = parseFloat(this.editTaskFeeData.rewardFee);
            this.editTaskFeeData.taskFee = parseFloat(this.editTaskFeeData.taskFee);
            let res = await api.updateTaskFee(this.editTaskFeeData);
            if(res.data.code == '200'){
                this.isEditTaskFeeTip = false;
                this.queryDoubtTasksByAnXinDcTaskId();
            }
            
        },

        async anXinDcTaskQueryCaseTypeByAnXinDcTaskId(){
            let res = await api.anXinDcTaskQueryCaseTypeByAnXinDcTaskId(this.$route.query.anXinDcTaskId);
            this.cSvyModeData = res.data.data;
            if(this.surveyDataInfo.cConclusion=='1'&&this.surveyDataInfo.isbdCase&&this.surveyDataInfo.isFive&&this.cSvyModeData.cSvyMode=='全案'){
                this.isBigCase = true;
            }else{
                this.isBigCase = false;
            }
        },


        isBigCaseChange(){
            
            if(this.surveyDataInfo.cConclusion=='1'&&this.surveyDataInfo.isbdCase&&this.surveyDataInfo.isFive&&this.cSvyModeData.cSvyMode=='全案'){
                this.isBigCase = true;
            }else{
                this.isBigCase = false;
            }
            // this.updateCccnn();
        },

        editTaskFeeTip(row){
            this.editTaskFeeData.doubtTaskId = row.id;
            this.editTaskFeeData.taskFee = row.taskFee;
            this.editTaskFeeData.rewardFee = row.rewardFee;
            this.editTaskFeeData.taskFeeReason = row.taskFeeReason?row.taskFeeReason:'';
            this.editTaskFeeData.dcyq = row.dcyq;
            this.editTaskFeeData.isZhuPaiJiGou = row.isZhuPaiJiGou;

            this.isEditTaskFeeTip = true;
        },

        async downFileDoubtCourse(scope){

            
            const loading = this.$loading({
          lock: true,
          text: '下载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

            let res = await api.downFileDoubtCourse(scope.row.id,{
                zipName:scope.row.dcTaskSubJect
            });

            loading.close();
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        display: flex;
        align-items: center;
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
    /deep/.el-textarea.is-disabled .el-textarea__inner{
        color:#606266;
    }
    .index{
        padding:0 10px;
        padding-top:60px
    }
    .top{
        width:100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding:10px 0;
        // top:60px;
        top:0px;
        left:0px;
        background-color: #ffffff;
        position:fixed;
        z-index: 60;
        /deep/.el-step__title{
           font-weight: bold; 
        }
    }
    .handle{
        margin-bottom: 10px;
    }
    .section{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 15px;
        padding-bottom: 10px;
        .title{
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 12px;
            background-color: #DEDEDE;
            padding:8px 15px;
        }
        .title-s{
            display: flex;
            justify-content: space-between;
        }
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 120px;
            }
            .value{
                width: 220px;
                .value-textarea{
                    border:1px solid #DCDFE6;
                    width: 564px;
                    min-height: 50px;
                    border-radius: 4px;
                    padding: 5px 14px;
                    font-size: 13px;
                    line-height: 24px;
                }
            }
            .piclist{
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                padding:10px 15px;
                .label{
                    width: 230px;
                    font-size: 14px;
                }
                .pics{
                    display: flex;
                    flex-wrap: wrap;
                    .pics-item{
                        width: 100px;
                        height: 100px;
                        position: relative;
                        margin: 15px;
                        .img{
                            width: 100px;
                            height: 100px;
                        }
                        .close{
                            position: absolute;
                            top: -12px;
                            right: -12px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .uploadbtn{
                    border: 1px solid #dcdcdc;
                    width: 106px;
                    height: 106px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 15px;
                    img{
                        width: 106px;
                        height: 106px;
                    }
                }
                
            }
        }
        .tip{
            width:100%;
            color:red;
            font-size: 12px;
            padding-left:15px
        }
    }
    .item{
        font-size: 14px;
        padding:10px 15px;
        display: flex;
        align-items: center;
        .label{
            margin-bottom: 5px;
            width: 120px;
        }
        .value{
            width: 220px;
            display: flex;
        }
        .piclist{
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding:10px 15px;
            .label{
                width: 230px;
                font-size: 14px;
            }
            .pics{
                display: flex;
                flex-wrap: wrap;
                .pics-item{
                    width: 100px;
                    height: 100px;
                    position: relative;
                    margin: 15px;
                    .img{
                        width: 100px;
                        height: 100px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .uploadbtn{
                border: 1px solid #dcdcdc;
                width: 106px;
                height: 106px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 15px;
                img{
                    width: 106px;
                    height: 106px;
                }
            }
            
        }
    }
    .btns{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .taskreason{
        span{
            color: red;
            font-size: 18px;
        }
        font-size: 14px;
        margin: 10px 0;
    }
    .materiallist{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 15px;
        align-items: center;
        .material{
            border: 1px dashed #dcdcdc;
            width: 150px;
            padding-top: 15px;
            padding-bottom: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            border-radius: 4px;
            margin:10px;
            position: relative;
            float: left;
            img{
                width: 120px;
            }
            .close{
                width: 25px;
                height: 25px;
                position: absolute;
                right: 3px;
                top: 3px;
            }
            .filename{
                width: 130px;
                font-size: 12px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                margin-top: 2px;
            }
        }
    }
    .section-item{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #DEDEDE;
        margin-bottom: 10px;
        .stitle{
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #f1f1f1;
            width: 100%;
            font-weight: bold;
            font-size: 16px;
            border-bottom:1px solid #DEDEDE;
            padding:8px 15px;
            span{
                font-size: 14px;
                font-weight: 500;
                margin: 0 10px;
            }
            .stitle-r{
                font-weight: 400;
                color:blue;
                font-size: 13px;
            }
            .stitle-l{
                display: flex;
                align-items: center;
                img{
                    width: 18px;
                    height: 18px;
                    margin-left: 10px;
                }
            }
            .stitle-audit{
                height: 20px;
                display: flex;
                align-items: center;
            }
        }
        i{
            font-size: 20px;
            font-weight: bold;
            margin-left: 10px;
            cursor: pointer;
        }
    }
    .section-btns{
        width: 100%;
        display: flex;
        justify-content: center;
        /deep/.el-button{
            margin: 0 20px;
        }
    }

    .product-report{
        font-size: 16px;
        color:#000000;
        margin: 10px 0;
        span{
            font-size: 14px;
            color:#606266;
        }
    }
    .product-report-btn{
        display: flex;
        justify-content: center;
    }
    .product-report-radio{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 70px;
        margin-top: 20px;
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 14px;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
</style>
